import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IPlatformUserSubscriptionVm } from '../platform-user-subscription-vm.model';
import { IPlatformUserSubscriptionUm } from '../platform-user-subscription-um.model';
@Injectable({ providedIn: 'root' })
export class PlatformUserSubscriptionService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/PlatformUserSubscription`;
  }
  put(platformUserSubscriptionUm: IPlatformUserSubscriptionUm): Observable<IPlatformUserSubscriptionVm> {
    const headers = this.createHeaders();
    return this.http.put<IPlatformUserSubscriptionVm>(this.baseUrl, platformUserSubscriptionUm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
